import * as constants from './constants';
import { LIST_ORDER } from '../../attrs/sorter_default_values';

const loadMachineMetricsAlertHistory = (
  params = {
    page: 1,
    limit: 5,
    sort: 'created_at',
    order: LIST_ORDER,
    machine_ids: '',
    from: '',
    to: ''
  }
) => ({
  type: constants.LOAD_MACHINE_METRICS_ALERT_HISTORY,
  ...params
});

export { loadMachineMetricsAlertHistory };
